import styled from 'styled-components';

export const ResqlExpertStyled = styled.section`
  display: flex;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: stretch;
  grid-area: main;
  min-width: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  overflow: hidden;
`;
